import { tenantApi } from '@/modules/tenant/services/tenantApi';
import type { Payment, RefundPaymentRequest, StorePaymentRequest } from '../types/service.types';

/**
 * D8-05: deliberately no update, no delete — payments are an append-only
 * event log; corrections are refund rows (`refund()` below, D14-12) and
 * credit notes (`creditNoteApi.ts`, F-INV-08, v1.2).
 */
export const paymentApi = {
  listForWorkOrder: (workOrderId: string) =>
    tenantApi.getList<Payment>(`/work-orders/${workOrderId}/payments`),

  get: (id: string) => tenantApi.getOne<Payment>(`/payments/${id}`),

  record: (workOrderId: string, data: StorePaymentRequest) =>
    tenantApi.postOne<Payment>(`/work-orders/${workOrderId}/payments`, data),

  refund: (paymentId: string, data: RefundPaymentRequest) =>
    tenantApi.postOne<Payment>(`/payments/${paymentId}/refund`, data),
};
